import { Injectable } from "@angular/core";
import { CaptchaActions } from "../actions";
import { genericRetry } from "@app/shared/operators/genericRetry";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Captcha } from "@smash-sdk-private/captcha/ejs/10-2025";
import VerifyChallengeError from "@smash-sdk-private/captcha/ejs/10-2025/types/VerifyChallenge/VerifyChallengeError";
import { concatMap, defer, of, catchError } from "rxjs";
import { Constant } from "src/constant";


@Injectable()
export class CaptchaEffects {
    constructor(
        private actions$: Actions,
    ) { }

    verifyCaptcha$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CaptchaActions.VerifyCaptcha),
            concatMap(({ token, action }) => {
                const captchaSdk = new Captcha();
                return defer(() => captchaSdk.verifyChallenge({ token, action })).pipe(
                    genericRetry({
                        retryConfig: [
                            ...Constant.NetworkErrorsRetryConfiguration,
                            { error: VerifyChallengeError.InternalServerError, maxRetry: 0, exponentialBackoff: true },
                            { error: VerifyChallengeError.GatewayTimeoutError, maxRetry: 10, exponentialBackoff: true },
                            { error: VerifyChallengeError.BadGatewayError, maxRetry: 10, exponentialBackoff: true },
                        ]
                    }),
                    concatMap(({ challenge }) => {
                        return of(CaptchaActions.VerifyCaptchaSuccess({ result: challenge.status }));
                    }),
                    catchError((error) => {
                        return of(CaptchaActions.VerifyCaptchaFailure({ error: error.message }));
                    })
                )
            })
        )
    );

}